import { TabContext, TabList, TabPanel } from '@mui/lab';
import {
	Typography,
	Tab,
	Box,
	styled,
	Grid,
	Stack,
	CircularProgress,
	InputAdornment,
	TextField,
} from '@mui/material';

import { SyntheticEvent, useCallback, useEffect, useState } from 'react';

import { useSelector, useDispatch } from 'react-redux';

import { capitalize } from 'lodash';

import { addRelationshipMapping as addNewHorizonMapping } from 'common/api';
import { ReactComponent as Plus } from 'common/assets/images/Plus.svg';
import { ReactComponent as SearchOutlined } from 'common/assets/images/search-outline.svg';
import { ReactComponent as SortIcon } from 'common/assets/images/sort-icon.svg';
import ButtonComp from 'common/components/Button/ButtonComp';
import CardTable from 'common/components/CardTable/CardTable';
import SelectDropdown from 'common/components/Select/SelectDropdown';
import SideDrawer from 'common/components/SideDrawer/SideDrawer';
import AlertComponent from 'common/components/ToastMessage/ToastMessage';
import { MODULES, SORT_ORDER, TABLE_VIEW_PAGE_SIZE } from 'common/constants';
import { PROGRESS_BAR_ELEMENTS } from 'common/constants/CitationDetails';
import { HTTP_STATUS_CODES } from 'common/constants/HttpStatusConstants';
import {
	ACTION_PLAN_TAB_CONSTANTS,
	tableAnnonationDataTaskData,
	RELATED_OBJECT_TYPE,
	ENTITY_STATUS,
	ENTITY_TYPE,
} from 'common/constants/TaxonomyConstants';
import { APP_GENERAL_ERROR_MSG } from 'common/constants/TextContent';
import { RootState } from 'common/store/AppStore';
import { setActionPlanTabIndex } from 'common/store/reducer/horizonScanReducer';
import { setSelectedTabValue } from 'common/store/reducer/mappingDetailsReducer';
import { capitalizeEachWord, toSentenceCase } from 'common/utils/utilFunctions';

import useTableQuery from 'hooks/useTableQuery';

import {
	getRelationshipForObligation,
	updateTaskWorkflow,
	generateAIRelMappingCards,
} from 'features/HorizonScanning/api';
import { IStyledTabProps } from 'features/HorizonScanning/api/type-def';
import {
	HORIZON_PROGRESS_BAR_ELEMENTS,
	HORIZON_EXPORT_COLUMNS,
} from 'features/HorizonScanning/HorizonScanConstants';
import { horizonScanRelationList } from 'features/HorizonScanning/horizonScanUtils';
import {
	IMappingEnity,
	IRelationshipMappingPayload,
} from 'features/RegulationInventory/api/type-def';
import AIMappingCard from 'features/RiskProfile/Taxonomy/RelationMapping/AIMappingCard';
import DetailedMappingLayout from 'features/RiskProfile/Taxonomy/RelationMapping/MappingDetail/DetailedMappingLayout';
import { AnnotationType } from 'features/RiskProfile/Taxonomy/RemediationPlan/api/type-def';

import { getRelationshipMappingData } from '../../api/index';

import ComplianceAcceptanceModal from '../ComplianceAcceptanceModal/ComplianceAcceptanceModal';

import ActionPlanTaskTable from './ActionPlanTaskTable';

import styles from './ActionPlanLayout.module.scss';

const { backgroundColor, borderColor } = styles;

const StyledTextField = styled(TextField)(() => ({
	background: backgroundColor,
	borderRadius: '4px',
	border: `1px solid ${borderColor}`,
	width: '60%',
}));

const { TAB_TASKS } = ACTION_PLAN_TAB_CONSTANTS;
const { TABLE_SIZE_12 } = TABLE_VIEW_PAGE_SIZE;

export {
	useCallback,
	useEffect,
	useState,
	Typography,
	Tab,
	Box,
	styled,
	Grid,
	Stack,
	CircularProgress,
	InputAdornment,
	TabContext,
	TabList,
	TabPanel,
	capitalize,
	useSelector,
	useDispatch,
	setActionPlanTabIndex,
	Plus,
	SortIcon,
	SideDrawer,
	CardTable,
	AIMappingCard,
	DetailedMappingLayout,
	addNewHorizonMapping,
	updateTaskWorkflow,
	MODULES,
	SORT_ORDER,
	TABLE_SIZE_12,
	PROGRESS_BAR_ELEMENTS,
	ButtonComp,
	capitalizeEachWord,
	toSentenceCase,
	SelectDropdown,
	HORIZON_PROGRESS_BAR_ELEMENTS,
	HORIZON_EXPORT_COLUMNS,
	horizonScanRelationList,
	HTTP_STATUS_CODES,
	AlertComponent,
	APP_GENERAL_ERROR_MSG,
	StyledTextField,
	SearchOutlined,
	TAB_TASKS,
	tableAnnonationDataTaskData,
	RELATED_OBJECT_TYPE,
	ENTITY_STATUS,
	ENTITY_TYPE,
	setSelectedTabValue,
	ActionPlanTaskTable,
	getRelationshipMappingData,
	getRelationshipForObligation,
	ComplianceAcceptanceModal,
	useTableQuery,
	styles,
	generateAIRelMappingCards,
};

export type {
	SyntheticEvent,
	RootState,
	IMappingEnity,
	IRelationshipMappingPayload,
	IStyledTabProps,
	AnnotationType,
};
